import React from "react";
import { useTable } from "react-table";
import "./SmallDataTable.css";

const SmallInvoiceTable = ({
  columns,
  data,
  billingType,
  totalBillingAmount,
}) => {
  // Add Sr. No. column at the beginning
  const columnsWithSrNo = React.useMemo(() => {
    return [
      {
        Header: "Sr. No.",
        id: "srno",
        Cell: ({ row }) => row.index + 1, // auto numbering
      },
      ...columns,
    ];
  }, [columns]);

  const tableInstance = useTable({
    columns: columnsWithSrNo,
    data: data || [],
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  // Check if we need to show merged billing amount column
  const showMergedBillingAmount =
    billingType === "Lumpsum Monthly" && totalBillingAmount;

  return (
    <div className="table-container">
      <table {...getTableProps()} className="custom-table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} key={column.id}>
                  {column.render("Header")}
                </th>
              ))}
              {showMergedBillingAmount && (
                <th style={{ textAlign: "center" }}>Billing Amount (₹)</th>
              )}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, rowIndex) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} key={cell.column.id}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                  {showMergedBillingAmount && rowIndex === 0 && (
                    <td
                      style={{
                        textAlign: "center",
                        verticalAlign: "middle",
                        // backgroundColor: "white",
                        fontWeight: "500",
                        border: "1px solid #dee2e6",
                        padding: "12px 8px",
                        fontSize: "14px",
                      }}
                      rowSpan={rows.length}
                    >
                      {totalBillingAmount}
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={
                  columnsWithSrNo.length + (showMergedBillingAmount ? 1 : 0)
                }
                className="no-data-message"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SmallInvoiceTable;
